<section class="mx-3">
    <div>
        <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="page_header">
                <h3 class="m-0 page_header_title">Employee Details</h3>
            </div>
            <div *ngIf="actiondata.create" class="d-flex button-row">
                <div class="px-3">
                    <div class="bulk_button">
                        <!-- <input #csvInput hidden="true" type="file" onclick="this.value=null" (change)="csvInputChange($event)" /> -->
                        <button mat-raised-button class="bulk_button_add add_button"
                            (click)="openUploadDialog('details', 'EMPLOYEES_BULKUPLOAD_TEMPLATE')">
                            <img src="../../../assets/icons/fileupload.svg" class="me-2" alt="upload icon" />
                            <span>Bulk Upload</span></button>
                        <button mat-raised-button class="m-0 p-0 bulk_button_view" [matMenuTriggerFor]="menu"
                            color="primary">
                            <mat-icon class="m-0">expand_more</mat-icon></button>
                    </div>
                    <mat-menu #menu="matMenu" class="download_menu">
                        <button mat-menu-item (click)="openUploadDialog('details', 'EMPLOYEES_BULKUPLOAD_TEMPLATE')">
                            Upload Employee Details
                        </button>
                        <button mat-menu-item (click)="openUploadDialog('images','employeImages')">
                            Upload Employee Images
                        </button>
                        <button mat-menu-item (click)="openUploadDialog('images','employeImages')">
                            Download Template Employee
                        </button>
                    </mat-menu>
                </div>
                <div>
                    <button mat-raised-button color="primary" class="px-5" (click)="navigatetoadd()">Add</button>
                </div>
            </div>
        </div>
        <ng-container *ngIf="actiondata.list_view">
            <div class="mt-2 table-container">
                <div class="d-flex align-items-center m-2">
                    <div class="filter_icon">
                        <div style="color:rgb(19, 19, 19);" [matMenuTriggerFor]="filterMenu" #menuTrigger="matMenuTrigger"><img
                                src="../../../assets/icons/filter_Icon.svg" alt="filter_icon" /> Filter</div>
                        <mat-menu #filterMenu="matMenu">
                            <div class="mx-3" (click)="$event.stopPropagation()">
                                <form [formGroup]="EmployeeFilterForm">
                                    <div *ngFor="let question of EmployeeFilterFormQuestions">
                                        <app-question [question]="question" [form]="EmployeeFilterForm"></app-question>
                                    </div>
                                    <div class="mt-2">
                                        <button mat-button color="primary" type="button" (click)="filterEmployees($event); menuTrigger.closeMenu()">
                                        <mat-icon>filter_list_alt</mat-icon>Filter </button>
                                        <button mat-button color="warn" class="m-2" (click)="clearFilter(); menuTrigger.closeMenu()">Clear</button>
                                    </div>
                                </form>
                            </div>
                        </mat-menu>
                    </div>
                    <!-- <div>
      <mat-icon class="material-symbols-outlined" style="color:rgb(160, 160, 160);">more_vert</mat-icon>
    </div>  -->
                </div>
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!-- Checkbox Column -->
                    <!-- <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? toggleAllRows() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                            [aria-label]="checkboxLabel(row)">
                        </mat-checkbox>
                    </td>
                </ng-container> -->

                    <!-- Position Column -->
                    <!-- <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container> -->

                    <!-- Name Column -->
                    <ng-container matColumnDef="Name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.first_name}} {{element.last_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.professional_email}} </td>
                    </ng-container>
                    <ng-container matColumnDef="phone_number">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Mobile Number </th>
                        <td mat-cell *matCellDef="let element"> {{element.phone_number}} </td>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="employee_unique_id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Faculty Unique ID </th>
                        <td mat-cell *matCellDef="let element"> {{element.employee_unique_id}} </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="designation_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Designation </th>
                        <td mat-cell *matCellDef="let element"> {{element.designation_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="organization_name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Department</th>
                        <td mat-cell *matCellDef="let element"> {{element.department_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="Action" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="d-flex align-items-center">
                                <!-- View option as clickable text -->
                                <ng-container *ngIf="actiondata.view">
                                    <p (click)="gotoemplyeeview(element)" class="mb-0 cursor_pointer view_button">View
                                    </p>
                                </ng-container>

                                <!-- 3-dots menu for edit option -->
                                <ng-container *ngIf="actiondata.edit">
                                    <button mat-icon-button class="action_button" [matMenuTriggerFor]="menu"
                                        aria-label="Actions">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <!-- <button class="update_button" mat-menu-item (click)="editdata(element)"> -->
                                        <button class="update_button" mat-menu-item (click)="navigatetoedit(element)">
                                            <!-- <mat-icon>edit</mat-icon> -->
                                            <span>Edit</span>
                                        </button>
                                    </mat-menu>
                                </ng-container>
                            </div>
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
                    </tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">No data</td>
                    </tr>
                </table>
            </div>
            <div class="mt-2" *ngIf="total_count > 5">
                <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
            </div>
        </ng-container>
    </div>
</section>